export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',
  DASHBOARD_EDIT: 'dashboard.edit',
  DASHBOARD_DELETE: 'dashboard.delete',
  WIDGET_CREATE: 'widget.create',
  WIDGET_EDIT: 'widget.edit',
  WIDGET_DELETE: 'widget.delete',
  REPORTS_VIEW: 'reports.view',
  USERS_MANAGE: 'users.manage',
  ROLES_MANAGE: 'roles.manage',
  AUDIT_VIEW: 'audit.view',
  SETTINGS_MANAGE: 'settings.manage',
} as const;

export type PermissionKey = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export interface Permission {
  key: PermissionKey;
  name: string;
  description: string;
  category: string;
}
